import { render, staticRenderFns } from "./editRadio.vue?vue&type=template&id=3928601f&scoped=true"
import script from "./editRadio.vue?vue&type=script&lang=js"
export * from "./editRadio.vue?vue&type=script&lang=js"
import style0 from "./editRadio.vue?vue&type=style&index=0&id=3928601f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3928601f",
  null
  
)

export default component.exports